<template>
    <div class="col-12"  :id="code">
        <div class="form-group">
            <label v-if="label">{{$t(label)}}</label>
            <vue-dropzone :id="code"
                          :ref="code"
                          :options="dropZoneOptions"
                          @vdropzone-mounted="onDropZoneMounted"
                          @vdropzone-file-added="onDropZoneFileAdded"
                          @vdropzone-files-added="onDropZoneFilesAdded"
                          :class="{'has-file': files.length > 0}">
            </vue-dropzone>
        </div>
    </div>
</template>

<script>
    import {BASE_API_UPLOAD} from '@/axios';
    import Cookie from 'js-cookie';
    import {clickImage} from '@/shared/utils';
    import {mapState} from "vuex";
    import $ from "jquery";
    import {getArchiveModeDetailsByVersion} from "@/shared/archive-mode-utils";

    export default {
        props: {
            code: String,
            label: String,
            data: Array
        },
        computed: {
          ...mapState(['archiveModeVersion'])
        },
        data() {
            return {
                dropZoneOptions: {
                    url: BASE_API_UPLOAD + 'upload/save/new',
                    headers: {
                        'Authorization': `Bearer ` + Cookie.get('x_token_' + process.env.VUE_APP_NAME)
                    },
                    clickable: false
                },
                files: [],
                files_added: []
            }
        },
        methods: {
            initFiles() {
                const dropZone = this.$refs[this.code];
                if (this.data && this.data.length > 0 && dropZone) {
                    this.data.forEach((file, index) => {
                        if (file && file.id && file.id > 0 && file.filePath && file.filePath.length > 0) {
                            if (!this.files_added.includes(file.id)) {
                                dropZone.manuallyAddFile(file, file.filePath);
                                this.files.push(file);
                                this.files_added.push(file.id);
                                let drop_zone_divs = $("#" + this.code + " > div.dz-preview .dz-image > img");
                                drop_zone_divs[index].setAttribute("url", file.filePath);
                            }
                        }
                    });
                  clickImage("#" + this.code);
                }
            },
            onDropZoneMounted() {
                this.initFiles();
            },
            onDropZoneFileAdded(file) {
                this.onFileAdded(file);
            },
            onDropZoneFilesAdded(files){
                if (files && files.length > 0) {
                    for (let i = 0; i < files.length; i++) {
                        this.onFileAdded(files[i]);
                    }
                }
            },
            onFileAdded(file) {
                if (file && file.type && file.type.length > 0 && file.type.startsWith('image')) {
                    file.previewElement.addEventListener("click", () => {
                        // this.$eventBus.$emit('showDropZoneImagePreview', {
                        //     url: (file.filePath && file.filePath.length > 0 ? file.filePath : file.dataURL)
                        // });
                        // console.log('file_details_clicked', file.filePath);
                    });
                }
            },
            updateDropzoneURL() {
              this.dropZoneOptions.url = (this.archiveModeVersion ? getArchiveModeDetailsByVersion(this.archiveModeVersion).url : BASE_API_UPLOAD) + 'upload/save/new';
              if(this.$refs[this.$props.code] && this.$refs[this.$props.code].dropzone && this.$refs[this.$props.code].dropzone.options) {
                this.$refs[this.$props.code].dropzone.options.url = (this.archiveModeVersion ? getArchiveModeDetailsByVersion(this.archiveModeVersion).url : BASE_API_UPLOAD) + 'upload/save/new'
              }
            }
        },
        watch: {
            data: {
                immediate: true,
                // handle the changed value
                handler(val) {
                    console.log(val);
                    this.initFiles();
                }
            }
        }
    }
</script>

<style scoped>

</style>